import { Link, LinkProps } from 'src/components';
import { FC, PropsWithChildren } from 'react';

type PaginationLinkProps = PropsWithChildren<LinkProps & { disabled?: boolean }>;

export const PaginationLink: FC<PaginationLinkProps> = ({ children, disabled, ...props }) => {
  return disabled ? <>{children}</> : <Link {...props}>{children}</Link>;
};
